import { render, staticRenderFns } from "./OpenShiftResponseDetails.vue?vue&type=template&id=b47c72e6&"
import script from "./OpenShiftResponseDetails.vue?vue&type=script&lang=ts&"
export * from "./OpenShiftResponseDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports